import Vue from 'vue';
import VueRouter from 'vue-router';
import PageNotFound from '@/views/PageNotFound';
import MainComponent from '@/components/MainComponent';
import AuthComponent from '@/components/AuthComponent';
import {getFromLocalStorage} from '@/utils/local-storage.util';
import AccessDenied from '@/views/AccessDenied';
import LogoutView from '@/views/LogoutView';
import {changeUserPrivileges, USER_PRIVILEGES} from '@/store/modules/authentication';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: MainComponent,
    children: [
      {
        path: '',
        component: () => import('../views/main/HomeView.vue'),
        meta: {
          auth: true
        },
        children: [
          {
            path: 'admin',
            component: () => import('../layouts/config/ConfigurationLayout.vue'),
            children: [
              {
                path: 'pages',
                component: () => import('../layouts/EmptyLayout.vue'),
                children: [
                  {
                    path: 'home',
                    name: 'page-home',
                    component: () => import('../views/configurations/pages/HomeView.vue'),
                    meta: {
                      permissions: ['admin-get']
                    }
                  },
                  // {
                  //   path: 'about-us',
                  //   name: 'page-about-us',
                  //   component: () => import('../views/configurations/pages/AboutUsView.vue'),
                  //   meta: {
                  //     permissions: ['admin-get']
                  //   }
                  // },
                  // {
                  //   path: 'why-we',
                  //   name: 'page-why-we',
                  //   component: () => import('../views/configurations/pages/WhyWeView.vue'),
                  //   meta: {
                  //     permissions: ['admin-get']
                  //   }
                  // },
                  // {
                  //   path: 'skills',
                  //   name: 'page-skills',
                  //   component: () => import('../views/configurations/pages/SkillView.vue'),
                  //   meta: {
                  //     permissions: ['admin-get']
                  //   }
                  // },
                  {
                    path: 'contacts',
                    name: 'page-contacts',
                    component: () => import('../views/configurations/pages/ContactView.vue'),
                    meta: {
                      permissions: ['admin-get']
                    }
                  },
                  // {
                  //   path: 'fun-facts',
                  //   name: 'page-fun-facts',
                  //   component: () => import('../views/configurations/pages/FunFactView.vue'),
                  //   meta: {
                  //     permissions: ['admin-get']
                  //   }
                  // },
                  {
                    path: 'social-links',
                    name: 'page-social-links',
                    component: () => import('../views/configurations/pages/SocialLinkView.vue'),
                    meta: {
                      permissions: ['admin-get']
                    }
                  },
                  // {
                  //   path: 'services',
                  //   name: 'page-services',
                  //   component: () => import('../views/configurations/pages/ServiceView.vue'),
                  //   meta: {
                  //     permissions: ['admin-get']
                  //   }
                  // },
                  // {
                  //   path: 'projects',
                  //   name: 'page-projects',
                  //   component: () => import('../views/configurations/pages/ProjectView.vue'),
                  //   meta: {
                  //     permissions: ['admin-get']
                  //   }
                  // },
                  // {
                  //   path: 'testimonials',
                  //   name: 'page-testimonials',
                  //   component: () => import('../views/configurations/pages/TestimonialView.vue'),
                  //   meta: {
                  //     permissions: ['admin-get']
                  //   }
                  // },
                  // {
                  //   path: 'staff',
                  //   name: 'page-staff',
                  //   component: () => import('../views/configurations/pages/StaffView.vue'),
                  //   meta: {
                  //     permissions: ['admin-get']
                  //   }
                  // },
                  {
                    path: 'faq',
                    name: 'page-faq',
                    component: () => import('../views/configurations/pages/FaqView.vue'),
                    meta: {
                      permissions: ['admin-get']
                    }
                  },
                  {
                    path: 'privacy-policy',
                    name: 'page-privacy-policy',
                    component: () => import('../views/configurations/pages/PrivacyPolicyView.vue'),
                    meta: {
                      permissions: ['admin-get']
                    }
                  },
                  {
                    path: 'public-offer',
                    name: 'page-public-offer',
                    component: () => import('../views/configurations/pages/PublicOfferView.vue'),
                    meta: {
                      permissions: ['admin-get']
                    }
                  }
                ]
              },
              {
                path: 'user-management',
                component: () => import('../layouts/EmptyLayout.vue'),
                children: [
                  {
                    path: 'user-groups',
                    name: 'user-groups-configurations',
                    component: () => import('@/views/configurations/user-management/UserGroupsView.vue'),
                    meta: {
                      permissions: ['admin-get']
                    }
                  },
                  {
                    path: 'users',
                    name: 'users-configurations',
                    component: () => import('@/views/configurations/user-management/UsersView.vue'),
                    meta: {
                      permissions: ['admin-get']
                    }
                  }
                ]
              },
            ]
          },
          {
            path: 'finance',
            component: () => import('../layouts/config/FinanceConfigurationLayout.vue'),
            children: [
              {
                path: 'arrival-product-markup',
                name: 'finance-arrival-product-markup',
                component: () => import('../views/finance/arrival-product-markup/ArrivalProductMarkupsView.vue'),
                meta: {
                  permissions: ['finance-get']
                }
              },
              {
                path: 'currency',
                name: 'finance-currency',
                component: () => import('../views/finance/CurrencyView.vue'),
                meta: {
                  permissions: ['finance-get']
                }
              },
              {
                path: 'rates',
                component: () => import('../layouts/EmptyLayout.vue'),
                children: [
                  {
                    path: 'exchange-rates',
                    name: 'exchange-rates',
                    component: () => import('../views/finance/rates/ExchangeRateGroupsView.vue'),
                    meta: {
                      permissions: ['finance-get']
                    }
                  },
                  {
                    path: 'coin-rates',
                    name: 'coin-rates',
                    component: () => import('../views/finance/rates/CoinRateGroupsView.vue'),
                    meta: {
                      permissions: ['finance-get']
                    }
                  },
                ]
              },
              {
                path: 'transactions',
                component: () => import('../layouts/EmptyLayout.vue'),
                children: [
                  {
                    path: 'coins',
                    name: 'coins',
                    component: () => import('../views/finance/transactions/CoinTransactionsView.vue'),
                    meta: {
                      permissions: ['finance-get']
                    }
                  },
                  {
                    path: 'purchases',
                    name: 'purchases',
                    component: () => import('../views/finance/transactions/PurchaseTransactionsView.vue'),
                    meta: {
                      permissions: ['finance-get']
                    }
                  },
                ]
              },
              {
                path: 'policies',
                component: () => import('../layouts/EmptyLayout.vue'),
                children: [
                  {
                    path: 'price-policy',
                    name: 'price-policy',
                    component: () => import('../views/finance/policies/PricePolicyView.vue'),
                    meta: {
                      permissions: ['finance-get']
                    }
                  },
                  // {
                  //   path: 'price-coins-policy',
                  //   name: 'price-coins-policy',
                  //   component: () => import('../views/finance/policies/ProductPriceCoinsPolicyView.vue'),
                  //   meta: {
                  //     permissions: ['finance-get']
                  //   }
                  // },
                  {
                    path: 'referral-bonus-policy',
                    name: 'referral-bonus-policy',
                    component: () => import('../views/finance/policies/ReferralBonusPolicyView.vue'),
                    meta: {
                      permissions: ['finance-get']
                    }
                  },
                  {
                    path: 'client-level-rules',
                    name: 'client-level-rules',
                    component: () => import('../views/finance/policies/ClientLevelsView.vue'),
                    meta: {
                      permissions: ['finance-get']
                    }
                  },
                ]
              },
            ]
          },
          {
            path: 'store',
            component: () => import('../layouts/config/ShopConfigurationLayout.vue'),
            children: [
              //orders, products, clients, product-reviews, requests, settings
              {
                path: 'orders',
                name: 'orders',
                component: () => import('../views/main/order/OrderView.vue'),
                meta: {
                  permissions: ['shop-get']
                }
              },
              {
                path: 'products',
                name: 'products',
                component: () => import('../views/main/product/ProductsView.vue'),
                meta: {
                  permissions: ['shop-get']
                }
              },
							{
								path: 'arrivals',
								name: 'arrivals',
								component: () => import('../views/main/arrival/ArrivalsView.vue'),
								meta: {
									permissions: ['shop-get']
								}
							},
              {
                path: 'mini-catalog',
                name: 'miniCatalog',
                component: () => import('../views/main/product/MiniProductsView.vue'),
                meta: {
                  permissions: ['shop-get']
                }
              },
              {
                path: 'clients',
                name: 'clients',
                component: () => import('../views/main/ClientsView.vue'),
                meta: {
                  permissions: ['shop-get']
                }
              },
              {
                path: 'banners',
                name: 'banners',
                component: () => import('../views/main/banners/BannersView.vue'),
                meta: {
                  permissions: ['shop-get']
                }
              },
              {
                path: 'blogs',
                name: 'blogs',
                component: () => import('../views/main/blog/BlogsView.vue'),
                meta: {
                  permissions: ['shop-get']
                }
              },
              {
                path: 'product-reviews',
                name: 'productReviews',
                component: () => import('../views/main/product/ProductReviewsView.vue'),
                meta: {
                  permissions: ['shop-get']
                }
              },
              {
                path: 'requests',
                component: () => import('../layouts/EmptyLayout.vue'),
                children: [
                  {
                    path: 'store',
                    name: 'requests-store',
                    component: () => import('../views/main/requests/RequestShopView.vue'),
                    meta: {
                      permissions: ['shop-get']
                    }
                  },
                ]
              },
              {
                path: 'settings',
                component: () => import('../layouts/EmptyLayout.vue'),
                children: [
                  {
                    path: 'colors',
                    name: 'settings-color',
                    component: () => import('../views/main/settings/ColorView.vue'),
                    meta: {
                      permissions: ['shop-get']
                    }
                  },
                  {
                    path: 'coupons',
                    name: 'settings-coupon',
                    component: () => import('../views/main/settings/CouponView.vue'),
                    meta: {
                      permissions: ['shop-get']
                    }
                  },
                  {
                    path: 'branches',
                    name: 'settings-branch',
                    component: () => import('../views/main/settings/BranchView.vue'),
                    meta: {
                      permissions: ['shop-get']
                    }
                  },
                  {
                    path: 'product-categories',
                    name: 'settings-product-category',
                    component: () => import('../views/main/settings/ProductCategoryView.vue'),
                    meta: {
                      permissions: ['shop-get']
                    }
                  },
                  {
                    path: 'product-subcategories',
                    name: 'settings-product-subcategory',
                    component: () => import('../views/main/settings/ProductSubcategoryView.vue'),
                    meta: {
                      permissions: ['shop-get']
                    }
                  },
                  {
                    path: 'product-brands',
                    name: 'settings-product-brand',
                    component: () => import('../views/main/settings/ProductBrandView.vue'),
                    meta: {
                      permissions: ['shop-get']
                    }
                  }
                ]
              },
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/',
    component: AuthComponent,
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import('../views/LoginView.vue')
      },
      {
        path: '/restore-user-password',
        name: 'restore-user-password',
        component: () => import('../views/UserRestorePasswordView.vue')
      },
      {
        path: '/confirm-restore-user-password',
        name: 'confirm-restore-user-password',
        component: () => import('../views/UserConfirmRestorePasswordView.vue')
      }
    ]
  },
  {
    path: '/logout',
    component: LogoutView
  },
  {
    path: '/access-denied',
    component: AccessDenied
  },
  {
    path: '*',
    component: PageNotFound
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// check redirect role,permission
router.beforeEach(async (to, from, next) => {
  const isLoggedIn = getFromLocalStorage('accessToken');
  
  if (to.matched.some((m) => m.meta.auth) && !isLoggedIn) {
    return next({
      path: `/login`,
      query: {
        redirectAfter: to.path
      }
    });
  }
  
  const tmpUser = getFromLocalStorage('user');
  if (isLoggedIn && tmpUser) {
    if (USER_PRIVILEGES === null) {
      const user = JSON.parse(tmpUser);
      // to clear localstorage and logout
      if (!user.userGroup) {
        localStorage.clear();
        location.reload();
      }
      changeUserPrivileges(user.userGroup.privileges);
    }
    
    const allRoutePermissions = to.matched
        .filter((m) => m.meta.permissions && m.meta.permissions.length)
        .reduce((acc, curr) => {
          acc.push(...curr.meta.permissions);
          return acc;
        }, []);
    
    if (!allRoutePermissions.every((role) => !!USER_PRIVILEGES[role])) {
      return next({
        path: '/access-denied',
        query: {
          fromPage: from.path
        }
      });
    }
  }
  
  // end check router prior with permission, role
  return next();
});

export default router;
